import { View, Text, type ViewProps } from 'react-native';

interface SectionHeaderProps extends ViewProps {
  title: string;
  action?: React.ReactNode;
}

export function SectionHeader({ title, action, className = '', ...rest }: SectionHeaderProps) {
  return (
    <View className={`flex-row items-center justify-between mb-3 ${className}`} {...rest}>
      <Text className="text-base font-semibold text-gray-800 dark:text-gray-200">{title}</Text>
      {action}
    </View>
  );
}
